export default "__VITE_ASSET__BqxROxGO__"